import Vue from 'vue';
import VueResource from 'vue-resource';

import {
  API_ROOT,
  studies,
  participants,
  activities,
  variable,
  variables,
  variablebyfilter,
  evaluate_variable,
  studyManagement,
  responsemanagement,
  revision,
  queryTool,
  activityRevisionId,
  study
} from './urls';

Vue.use(VueResource);

const createVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityId}${revision}{activityRevisionId}/${variable}`);
const updateVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityId}${revision}{activityRevisionId}/${variable}{/variableId}`);
const getAllVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variables}`);
const getVariableByFilter = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variablebyfilter}`);
const getVariableDetailResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}${revision}{activityRevisionId}/${variable}{/variableId}`);
const deleteVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variable}{/variableId}`);
const evaluateVariableResource = Vue.resource(`${API_ROOT}${responsemanagement}${studies}{/studyId}/${participants}{/participantId}/${activities}{/activityId}${revision}{activityRevisionId}/${variable}{/variableId}/${evaluate_variable}`);
const getActivityRevisionIdResource = Vue.resource(`${API_ROOT}${queryTool}/${study}{/studyId}/${activityRevisionId}`);

export function createVariable(pathParams, data) {
  return createVariableResource.save(pathParams, data);
}

export function updateVariable(pathParams, data) {
  return updateVariableResource.update(pathParams, data);
}

export function getAllVariables(pathParams, queryParams = {}) {
  return getAllVariableResource.get({...pathParams, ...queryParams});
}

export function getVariableDetails(pathParams) {
  return getVariableDetailResource.get(pathParams);
}
export function getFilterVariableDetails(pathParams, queryParams = {}) {
  return getVariableByFilter.get({...pathParams, ...queryParams})
}

export function deleteVariable(pathParams) {
  return deleteVariableResource.delete(pathParams);
}

export function evaluateVariable(pathParams, queryParams = {}) {
  return evaluateVariableResource.get({...pathParams, ...queryParams});
}

export function getActivityRevisionId(pathParams, queryParams = {}) {
  return getActivityRevisionIdResource.get({...pathParams, ...queryParams});
}
